import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";

import "./ordersStats.css";
import "react-datepicker/dist/react-datepicker.css";

import ArchieveOrder from "./_common/ArchieveOrder";

import {
  GeneralStatsPie,
  PopularDishesBar
} from "../../utils/ui_components/charts";
import Hint from "../../utils/Hint/Hint";

const OrdersStats = ({ orders }) => {
  const [historyOrders, setHistoryOrders] = useState(
    orders.length ? [...orders] : []
  );
  const [isHistoryOrdersLoading, setHistoryOrdersLoading] = useState(false);

  const handleDeleteOrder = (orderId) => {
    const workingArray = [...historyOrders.filter((o) => o._id !== orderId)];

    setHistoryOrders([...workingArray]);
  };
  const [isDropDownShown, setIsDropDownShown] = useState(false);

  // is range selected
  const [isSelectRange, setIsSelectRange] = useState(false);

  // select one date
  const [ordersDate, setOrdersDate] = useState(new Date().toISOString());
  // select date range
  const [startDate, setStartDate] = useState(new Date().toISOString());
  const [endDate, setEndDate] = useState(new Date().toISOString());

  // current orders
  const [currentOrders, setCurrentOrders] = useState([]);
  const [isCancelledHidden, setIsCancelledHidden] = useState(true);

  // statistics
  const [generalStats, setGeneralStats] = useState({});
  const [isGIPopDishesShown, setGIPopDishesShown] = useState(false);
  const [popDishesTierGI, setPopDishesTierGI] = useState(5);

  const [selectedStats, setSelectedStats] = useState({});
  const [isSIPopDishesShown, setSIPopDishesShown] = useState(false);
  const [popDishesTierSI, setPopDishesTierSI] = useState(5);

  const handleSelectDatepicker = () => {
    if (!isSelectRange) setIsSelectRange(true);
    if (isSelectRange) setIsSelectRange(false);
  };

  const handleDropDownShown = () => {
    if (!isDropDownShown) setIsDropDownShown(true);
    if (isDropDownShown) setIsDropDownShown(false);
  };

  const handleIsCancelledHidden = () => {
    if (!isCancelledHidden) setIsCancelledHidden(true);
    if (isCancelledHidden) setIsCancelledHidden(false);
  };

  const handleGIPopDishesShown = () => {
    if (!isGIPopDishesShown) setGIPopDishesShown(true);
    if (isGIPopDishesShown) setGIPopDishesShown(false);
  };

  const handleSetGIPopDishesTier = (e) => {
    setPopDishesTierGI(e.target.value);
  };

  const handleSIPopDishesShown = () => {
    if (!isSIPopDishesShown) setSIPopDishesShown(true);
    if (isSIPopDishesShown) setSIPopDishesShown(false);
  };

  const handleSetSIPopDishesTier = (e) => {
    setPopDishesTierSI(e.target.value);
  };

  const mode = (array) => {
    let counts = {};
    let compare = 0;
    let mostFrequent;

    for (let i = 0, len = array.length; i < len; i++) {
      let word = array[i].originalId;

      if (counts[word] === undefined) {
        counts[word] = 1 * array[i].amount;
      } else {
        counts[word] = counts[word] + 1;
      }
      if (counts[word] > compare) {
        compare = counts[word];
        mostFrequent = array[i];
        mostFrequent.orderedTimes = counts[mostFrequent.originalId];
      }
    }
    return mostFrequent;
  };

  const dishesTier = (array, depth = 5) => {
    let workingArray = [...array];
    let uniqueDishesArray = array.reduce(
      (acc, x) => acc.concat(acc.find((y) => y.name === x.name) ? [] : [x]),
      []
    );
    let innerDepth =
      uniqueDishesArray.length > depth
        ? depth
        : depth > uniqueDishesArray.length
        ? uniqueDishesArray.length
        : depth;
    let workingMostFrequent;
    const tier = [];

    try {
      for (let i = 0; i < innerDepth; i++) {
        workingMostFrequent = { ...mode(workingArray) };
        tier.push(workingMostFrequent);
        workingArray = workingArray.filter(
          (item) => item.originalId !== workingMostFrequent.originalId
        );
        workingMostFrequent = {};
      }
    } catch (err) {
      console.log(err);
    }

    return tier;
  };

  useEffect(() => {
    const stats = {};
    const allDishesArray = [];
    const takeOutDishesArray = [];
    const eatInDishesArray = [];
    stats.successOrders = [];
    stats.cancelledOrders = [];
    stats.totalSum = "";

    if (historyOrders.length > 0) {
      historyOrders.map((order) => {
        if (order.orderStatus === "fulfilled") {
          stats.successOrders.push(order);
        }
      });
      historyOrders.map((order) => {
        if (order.orderStatus === "cancelled") {
          stats.cancelledOrders.push(order);
        }
      });

      stats.ordersPaymentOnSpotSuccess = stats.successOrders.filter(
        (order) => order.orderPaymentType === "onSpot"
      );
      stats.ordersPaymentOnlineSuccess = stats.successOrders.filter(
        (order) => order.orderPaymentType === "online"
      );
      stats.ordersEatInSuccess = stats.successOrders.filter(
        (order) => order.orderTakeType === "eatIn"
      );
      stats.ordersTakeOutSuccess = stats.successOrders.filter(
        (order) => order.orderTakeType === "takeOut"
      );

      stats.totalSum = stats.successOrders.reduce((acc, order) => {
        return acc + order.orderSum;
      }, 0);
      stats.totalSumOnSpot = stats.ordersPaymentOnSpotSuccess.reduce(
        (acc, order) => {
          return acc + order.orderSum;
        },
        0
      );
      stats.totalSumOnline = stats.ordersPaymentOnlineSuccess.reduce(
        (acc, order) => {
          return acc + order.orderSum;
        },
        0
      );

      stats.totalSumEatIn = stats.ordersEatInSuccess.reduce((acc, order) => {
        return acc + order.orderSum;
      }, 0);
      stats.eatinSumOnSpot = stats.ordersEatInSuccess
        .filter((order) => order.orderPaymentType === "onSpot")
        .reduce((acc, order) => {
          return acc + order.orderSum;
        }, 0);
      stats.eatinSumOnline = stats.ordersEatInSuccess
        .filter((order) => order.orderPaymentType === "online")
        .reduce((acc, order) => {
          return acc + order.orderSum;
        }, 0);

      stats.totalSumTakeOut = stats.ordersTakeOutSuccess.reduce(
        (acc, order) => {
          return acc + order.orderSum;
        },
        0
      );
      stats.takeoutSumOnSpot = stats.ordersTakeOutSuccess
        .filter((order) => order.orderPaymentType === "onSpot")
        .reduce((acc, order) => {
          return acc + order.orderSum;
        }, 0);
      stats.takeoutSumOnline = stats.ordersTakeOutSuccess
        .filter((order) => order.orderPaymentType === "online")
        .reduce((acc, order) => {
          return acc + order.orderSum;
        }, 0);

      stats.successOrders.map((order) => {
        order.orderBody.map((dish) => {
          allDishesArray.push(dish);
        });
      });

      stats.ordersEatInSuccess.map((order) => {
        order.orderBody.map((dish) => {
          eatInDishesArray.push(dish);
        });
      });

      stats.ordersTakeOutSuccess.map((order) => {
        order.orderBody.map((dish) => {
          takeOutDishesArray.push(dish);
        });
      });

      stats.mostPopularDishesGeneral = dishesTier(
        allDishesArray,
        popDishesTierGI
      );
      stats.mostPopularDishesEatIn = dishesTier(
        eatInDishesArray,
        popDishesTierGI
      );
      stats.mostPopularDishesTakeOut = dishesTier(
        takeOutDishesArray,
        popDishesTierGI
      );

      setGeneralStats({ ...stats });
    }
  }, [historyOrders, popDishesTierGI]);

  useEffect(() => {
    if (!isSelectRange) {
      let dateFormatted = ordersDate.slice(0, 10);

      const orders = historyOrders.filter(
        (order) => order.orderDateFormatted === dateFormatted
      );

      setCurrentOrders((currentOrders) => [...orders]);
    } else if (isSelectRange) {
      let startDateFormatted = startDate.slice(0, 10);
      let endDateFormatted = endDate.slice(0, 10);

      const orders = historyOrders.filter(
        (order) =>
          order.orderDateFormatted >= startDateFormatted &&
          order.orderDateFormatted <= endDateFormatted
      );

      setCurrentOrders((currentOrders) => [...orders]);
    }
  }, [ordersDate, isSelectRange, startDate, endDate, historyOrders]);

  useEffect(() => {
    const stats = {};
    const allDishesArray = [];
    const takeOutDishesArray = [];
    const eatInDishesArray = [];
    stats.successOrders = [];
    stats.cancelledOrders = [];

    if (currentOrders.length && currentOrders.length > 0) {
      currentOrders.map((order) => {
        if (order.orderStatus === "fulfilled") {
          stats.successOrders.push(order);
        }
      });
      currentOrders.map((order) => {
        if (order.orderStatus === "cancelled") {
          stats.cancelledOrders.push(order);
        }
      });

      stats.ordersPaymentOnSpotSuccess = stats.successOrders.filter(
        (order) => order.orderPaymentType === "onSpot"
      );
      stats.ordersPaymentOnlineSuccess = stats.successOrders.filter(
        (order) => order.orderPaymentType === "online"
      );
      stats.ordersEatInSuccess = stats.successOrders.filter(
        (order) => order.orderTakeType === "eatIn"
      );
      stats.ordersTakeOutSuccess = stats.successOrders.filter(
        (order) => order.orderTakeType === "takeOut"
      );

      stats.totalSum = stats.successOrders.reduce((acc, order) => {
        return acc + order.orderSum;
      }, 0);
      stats.totalSumOnSpot = stats.ordersPaymentOnSpotSuccess.reduce(
        (acc, order) => {
          return acc + order.orderSum;
        },
        0
      );
      stats.totalSumOnline = stats.ordersPaymentOnlineSuccess.reduce(
        (acc, order) => {
          return acc + order.orderSum;
        },
        0
      );

      stats.totalSumEatIn = stats.ordersEatInSuccess.reduce((acc, order) => {
        return acc + order.orderSum;
      }, 0);
      stats.eatinSumOnSpot = stats.ordersEatInSuccess
        .filter((order) => order.orderPaymentType === "onSpot")
        .reduce((acc, order) => {
          return acc + order.orderSum;
        }, 0);
      stats.eatinSumOnline = stats.ordersEatInSuccess
        .filter((order) => order.orderPaymentType === "online")
        .reduce((acc, order) => {
          return acc + order.orderSum;
        }, 0);

      stats.totalSumTakeOut = stats.ordersTakeOutSuccess.reduce(
        (acc, order) => {
          return acc + order.orderSum;
        },
        0
      );
      stats.takeoutSumOnSpot = stats.ordersTakeOutSuccess
        .filter((order) => order.orderPaymentType === "onSpot")
        .reduce((acc, order) => {
          return acc + order.orderSum;
        }, 0);
      stats.takeoutSumOnline = stats.ordersTakeOutSuccess
        .filter((order) => order.orderPaymentType === "online")
        .reduce((acc, order) => {
          return acc + order.orderSum;
        }, 0);

      stats.successOrders.map((order) => {
        order.orderBody.map((dish) => {
          allDishesArray.push(dish);
        });
      });

      stats.ordersEatInSuccess.map((order) => {
        order.orderBody.map((dish) => {
          eatInDishesArray.push(dish);
        });
      });

      stats.ordersTakeOutSuccess.map((order) => {
        order.orderBody.map((dish) => {
          takeOutDishesArray.push(dish);
        });
      });

      stats.mostPopularDishesGeneral = dishesTier(
        allDishesArray,
        popDishesTierSI
      );
      stats.mostPopularDishesEatIn = dishesTier(
        eatInDishesArray,
        popDishesTierSI
      );
      stats.mostPopularDishesTakeOut = dishesTier(
        takeOutDishesArray,
        popDishesTierSI
      );

      setSelectedStats({ ...stats });
    }
  }, [currentOrders, popDishesTierSI]);

  return (
    <>
      {isHistoryOrdersLoading ? (
        <div className="archieveOrdersLoadingSpinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      ) : null}
      <section className="section ordersSection">
        <Hint
          hintHeading="Orders statistics"
          hintText={`
        <div>
        <div>
          This dashboard provides comprehensive statistics on the e-commerce system, helping to gather and analyze the information needed to successfully maintain and expand business activities.
          </div>
          <div>
          The statistics panel can be adjusted to the business' requirements.
          </div>
        </div>
        `}
          openOnMount={false}
          top="5em"
          right="3em"
        />
        <div className="subSection historyOrdersSubsection">
          <h2 className="sectionHeading">Orders statistics</h2>
          {historyOrders &&
          historyOrders.length &&
          Object.keys(generalStats).length ? (
            <div className="historyOrdersSubsection__generalInfoDiv">
              <div className="generalInfoDiv__heading">Overall statistics</div>
              <div className="generalInfoDiv__total">
                Overall orders:{" "}
                {historyOrders.length ? historyOrders.length : 0}
              </div>
              <div className="generalInfoDiv__totalSuccess">
                Fulfilled orders:{" "}
                {generalStats.successOrders.length
                  ? generalStats.successOrders.length
                  : 0}
              </div>
              <div className="generalInfoDiv__totalSum">
                Fulfilled orders total sum: {generalStats.totalSum} $
              </div>
              <div className="generalInfoDiv__averageOrder">
                Average order sum:{" "}
                {generalStats.successOrders.length > 0
                  ? Math.round(
                      generalStats.totalSum / generalStats.successOrders.length
                    )
                  : ""}{" "}
                $
              </div>
              <div className="generalInfoDiv__generalStatsPie">
                <GeneralStatsPie generalStats={generalStats} />
              </div>
              <h4
                style={{
                  textAlign: "center",
                  textTransform: "uppercase",
                  marginTop: "2em",
                  marginBottom: "0.3em"
                }}
              >
                Popular dishes
              </h4>
              <button
                className={`generalInfoDiv__toggleOpenPopDishesBtn
                                        ${
                                          isGIPopDishesShown
                                            ? "generalInfoDiv__toggleOpenPopDishesBtn--reversed"
                                            : ""
                                        }
                                    `}
                onClick={() => handleGIPopDishesShown()}
              >
                <svg
                  className="bi bi-chevron-compact-down"
                  width="2em"
                  height="2em"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3.553 8.776a.5.5 0 01.67-.223L10 11.44l5.776-2.888a.5.5 0 11.448.894l-6 3a.5.5 0 01-.448 0l-6-3a.5.5 0 01-.223-.67z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <div
                className={`generalInfoDiv__popularDishesDiv
                                    ${
                                      isGIPopDishesShown
                                        ? "generalInfoDiv__popularDishesDiv--shown"
                                        : ""
                                    }
                                `}
              >
                <div className="popularDishesDiv__selectTier">
                  <label htmlFor="selectGIPopDishesTier">
                    Top:
                    <input
                      type="number"
                      name="selectGIPopDishesTier"
                      id="selectGIPopDishesTier"
                      value={popDishesTierGI}
                      onChange={handleSetGIPopDishesTier}
                      min={5}
                    />
                  </label>
                </div>
                {generalStats.mostPopularDishesGeneral.length > 0 ? (
                  <div className="popularDishesDiv__dishesDiv">
                    <h3>All</h3>
                    <div className="dishesDiv__popularDishesBar">
                      <PopularDishesBar
                        rawData={generalStats.mostPopularDishesGeneral}
                      />
                    </div>
                    {generalStats.mostPopularDishesGeneral.map(
                      (dish, index) => (
                        <div
                          key={dish._id}
                          className="dishesDiv__mostPopularDishesDishItem"
                        >
                          <div>
                            {index + 1}) {dish.name}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            ordered times: {dish.orderedTimes}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                ) : null}
                {generalStats.mostPopularDishesEatIn.length > 0 ? (
                  <div className="popularDishesDiv__dishesDiv">
                    <h3>On spot</h3>
                    <div className="dishesDiv__popularDishesBar">
                      <PopularDishesBar
                        rawData={generalStats.mostPopularDishesEatIn}
                      />
                    </div>
                    {generalStats.mostPopularDishesEatIn.map((dish, index) => (
                      <div
                        key={dish._id}
                        className="dishesDiv__mostPopularDishesDishItem"
                      >
                        <div>
                          {index + 1}) {dish.name}
                        </div>
                        <div style={{ textAlign: "right" }}>
                          ordered times: {dish.orderedTimes}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
                {generalStats.mostPopularDishesTakeOut.length > 0 ? (
                  <div className="popularDishesDiv__dishesDiv">
                    <h3>Takeaway</h3>
                    <div className="dishesDiv__popularDishesBar">
                      <PopularDishesBar
                        rawData={generalStats.mostPopularDishesTakeOut}
                      />
                    </div>
                    {generalStats.mostPopularDishesTakeOut.map(
                      (dish, index) => (
                        <div
                          key={dish._id}
                          className="dishesDiv__mostPopularDishesDishItem"
                        >
                          <div>
                            {index + 1}) {dish.name}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            ordered times: {dish.orderedTimes}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
          <hr />
          <div className="historyOrdersSubsection__selectedStatsHeading">
            Statistics for a period
          </div>
          <div className="historyOrdersSubsection__controlsDiv">
            <div className="controlsDiv__datepickerDiv">
              {!isSelectRange ? (
                <>
                  <div className="datepickerDiv__helperDiv">Select a date</div>
                  <DatePicker
                    locale="en"
                    dateFormat="dd/MM/yyyy"
                    selected={new Date(ordersDate)}
                    onChange={(date) => setOrdersDate(date.toISOString())}
                  />
                </>
              ) : (
                <>
                  <div className="datepickerDiv__helperDiv">Select range</div>
                  <div className="datepickerDiv__labelDiv">from</div>
                  <DatePicker
                    locale="en"
                    dateFormat="dd/MM/yyyy"
                    selectsStart
                    selected={new Date(startDate)}
                    startDate={new Date(startDate)}
                    endDate={new Date(endDate)}
                    onChange={(date) => setStartDate(date.toISOString())}
                  />
                  <div className="datepickerDiv__labelDiv">to</div>
                  <DatePicker
                    locale="en"
                    dateFormat="dd/MM/yyyy"
                    selectsEnd
                    selected={new Date(endDate)}
                    startDate={new Date(startDate)}
                    endDate={new Date(endDate)}
                    onChange={(date) => setEndDate(date.toISOString())}
                  />
                </>
              )}
            </div>
            <button
              className="controlsDiv__selectDatepickerBtn"
              onClick={() => handleSelectDatepicker()}
            >
              {!isSelectRange
                ? "switch to range search"
                : "switch to day search"}
            </button>
          </div>
          {currentOrders.length && Object.keys(selectedStats).length ? (
            <div className="historyOrdersSubsection__selectedInfoDiv">
              <div className="selectedInfoDiv__heading">
                Data for the selected{" "}
                {!isSelectRange
                  ? `day ${ordersDate.slice(0, 10)}`
                  : `range\n from ${startDate.slice(0, 10)} to ${endDate.slice(
                      0,
                      10
                    )}`}
              </div>
              <div className="selectedInfoDiv__total">
                Overall orders:{" "}
                {currentOrders.length ? currentOrders.length : 0}
              </div>
              <div className="selectedInfoDiv__totalSuccess">
                Fulfilled orders:{" "}
                {selectedStats.successOrders.length
                  ? selectedStats.successOrders.length
                  : 0}
              </div>
              <div className="selectedInfoDiv__totalSum">
                Fulfilled orders total sum: {selectedStats.totalSum} $
              </div>
              <div className="selectedInfoDiv__averageOrder">
                Average order sum:{" "}
                {selectedStats.successOrders.length > 0
                  ? Math.round(
                      selectedStats.totalSum /
                        selectedStats.successOrders.length
                    )
                  : ""}{" "}
                $
              </div>
              <div className="generalInfoDiv__generalStatsPie">
                <GeneralStatsPie generalStats={selectedStats} />
              </div>
              <h4
                style={{
                  textAlign: "center",
                  textTransform: "uppercase",
                  marginBottom: "0.3em"
                }}
              >
                Popular dishes
              </h4>
              <button
                className={`generalInfoDiv__toggleOpenPopDishesBtn
                                        ${
                                          isSIPopDishesShown
                                            ? "generalInfoDiv__toggleOpenPopDishesBtn--reversed"
                                            : ""
                                        }
                                    `}
                onClick={() => handleSIPopDishesShown()}
              >
                <svg
                  className="bi bi-chevron-compact-down"
                  width="2em"
                  height="2em"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3.553 8.776a.5.5 0 01.67-.223L10 11.44l5.776-2.888a.5.5 0 11.448.894l-6 3a.5.5 0 01-.448 0l-6-3a.5.5 0 01-.223-.67z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <div
                className={`generalInfoDiv__popularDishesDiv
                                    ${
                                      isSIPopDishesShown
                                        ? "generalInfoDiv__popularDishesDiv--shown"
                                        : ""
                                    }
                                `}
              >
                <div className="popularDishesDiv__selectTier">
                  <label htmlFor="selectSIPopDishesTier">
                    Top:
                    <input
                      type="number"
                      name="selectSIPopDishesTier"
                      id="selectSIPopDishesTier"
                      value={popDishesTierSI}
                      onChange={handleSetSIPopDishesTier}
                      min={5}
                    />
                  </label>
                </div>
                {selectedStats.mostPopularDishesGeneral.length > 0 ? (
                  <div className="popularDishesDiv__dishesDiv">
                    <h3>All</h3>
                    <div className="dishesDiv__popularDishesBar">
                      <PopularDishesBar
                        rawData={selectedStats.mostPopularDishesGeneral}
                      />
                    </div>
                    {selectedStats.mostPopularDishesGeneral.map(
                      (dish, index) => (
                        <div
                          key={dish._id}
                          className="dishesDiv__mostPopularDishesDishItem"
                        >
                          <div>
                            {index + 1}) {dish.name}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            ordered times: {dish.orderedTimes}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                ) : null}
                {selectedStats.mostPopularDishesEatIn.length > 0 ? (
                  <div className="popularDishesDiv__dishesDiv">
                    <h3>On spot</h3>
                    <div className="dishesDiv__popularDishesBar">
                      <PopularDishesBar
                        rawData={selectedStats.mostPopularDishesEatIn}
                      />
                    </div>
                    {selectedStats.mostPopularDishesEatIn.map((dish, index) => (
                      <div
                        key={dish._id}
                        className="dishesDiv__mostPopularDishesDishItem"
                      >
                        <div>
                          {index + 1}) {dish.name}
                        </div>
                        <div style={{ textAlign: "right" }}>
                          ordered times: {dish.orderedTimes}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
                {selectedStats.mostPopularDishesTakeOut.length > 0 ? (
                  <div className="popularDishesDiv__dishesDiv">
                    <h3>Takeaway</h3>
                    <div className="dishesDiv__popularDishesBar">
                      <PopularDishesBar
                        rawData={selectedStats.mostPopularDishesTakeOut}
                      />
                    </div>
                    {selectedStats.mostPopularDishesTakeOut.map(
                      (dish, index) => (
                        <div
                          key={dish._id}
                          className="dishesDiv__mostPopularDishesDishItem"
                        >
                          <div>
                            {index + 1}) {dish.name}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            ordered times: {dish.orderedTimes}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
          <h3>Orders</h3>
          {historyOrders.length ? (
            currentOrders.length ? (
              <>
                <button
                  className="historyOrdersSubsection__toggleDropdownBtn"
                  onClick={() => handleDropDownShown()}
                >
                  {!isDropDownShown ? "show orders" : "hide orders"}
                </button>
                <div
                  className={`historyOrdersSubsection__dropdownDiv ${
                    isDropDownShown
                      ? "historyOrdersSubsection__dropdownDiv--shown"
                      : ""
                  }`}
                >
                  <button
                    className="dropdownDiv__toggleCancelledHistoryOrdersBtn"
                    onClick={() => handleIsCancelledHidden()}
                  >
                    {!isCancelledHidden
                      ? "hide cancelled orders"
                      : "show cancelled orders"}
                  </button>
                  {isCancelledHidden
                    ? currentOrders
                        .filter((o) => o.orderStatus !== "cancelled")
                        .map((order) => (
                          <ArchieveOrder
                            order={order}
                            key={order._id}
                            handleDeleteOneOrder={handleDeleteOrder}
                            isCancelledHidden={isCancelledHidden}
                          />
                        ))
                    : currentOrders.map((order) => (
                        <ArchieveOrder
                          order={order}
                          key={order._id}
                          handleDeleteOneOrder={handleDeleteOrder}
                          isCancelledHidden={isCancelledHidden}
                        />
                      ))}
                </div>
              </>
            ) : (
              <div className="historyOrdersSubsection__emptyMessageDiv">
                {!isSelectRange
                  ? `No orders found on the selected day ${ordersDate.slice(
                      0,
                      10
                    )}`
                  : `No orders found within the selected range from ${startDate.slice(
                      0,
                      10
                    )} to ${endDate.slice(0, 10)}`}
              </div>
            )
          ) : !isHistoryOrdersLoading ? (
            <div className="historyOrdersSubsection__emptyMessageDiv">
              <h2>Orders history is empty</h2>
            </div>
          ) : null}
        </div>
      </section>
    </>
  );
};

export default OrdersStats;
